import SectionHeading from "./SectionHeading";

interface Experience {
  title: string;
  subtitle: string;
  image: string;
}

// Unsplash placeholders — swap for your own imagery later.
const EXPERIENCES: Experience[] = [
  { title: "Heritage Walks", subtitle: "Walk through history", image: "https://images.unsplash.com/photo-1548013146-72479768bada?auto=format&fit=crop&w=600&q=70" },
  { title: "Food Trails", subtitle: "Taste the local flavors", image: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=600&q=70" },
  { title: "Cultural Events", subtitle: "Festivals & traditions", image: "https://images.unsplash.com/photo-1583089892943-e02e5b017b6a?auto=format&fit=crop&w=600&q=70" },
  { title: "Local Art & Craft", subtitle: "Handmade with love", image: "https://images.unsplash.com/photo-1610375461246-83df859d849d?auto=format&fit=crop&w=600&q=70" },
  { title: "Spiritual Tourism", subtitle: "Find peace within", image: "https://images.unsplash.com/photo-1561361513-2d000a50f0dc?auto=format&fit=crop&w=600&q=70" },
];

export default function TrendingExperiences() {
  return (
    <section id="experiences" className="bg-white py-20">
      <div className="container-page">
        <SectionHeading title="Trending Experiences" action="View All Experiences →" />
        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
          {EXPERIENCES.map((e) => (
            <div
              key={e.title}
              className="group relative h-44 overflow-hidden rounded-2xl shadow-card"
            >
              <img
                src={e.image}
                alt={e.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/90 via-navy-900/20 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-3">
                <h3 className="font-display text-sm font-semibold text-white">
                  {e.title}
                </h3>
                <p className="text-[11px] text-white/75">{e.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
